import { render, staticRenderFns } from "./PartnerUserEditModal.vue?vue&type=template&id=087f6a38"
import script from "./PartnerUserEditModal.vue?vue&type=script&lang=ts"
export * from "./PartnerUserEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports